import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/footer';
import { Paginator } from 'primereact/paginator';
import Warning from '../images/warning.png';
import Loader from '../components/loader';

function App() {

	const userID = sessionStorage.getItem("TRCUserId");
	const userEmail = sessionStorage.getItem("TRCUserEmail");
	const userName = sessionStorage.getItem("TRCUserName");
	const userPosition = sessionStorage.getItem("TRCUserPosition");
	const userType = sessionStorage.getItem("TRCUserType");
	const [loader, setLoader] = useState(false);
    const [getData, setGetData] = useState('');
	const [first, setFirst] = useState(0); 
	const [rows, setRows] = useState(10); 
	const [search, setSearch] = useState(null); 
	const [showPopup, setShowPopup] = useState(false);
	const [selectedDealer, setSelectedDealer] = useState(false);
	const[sortField, setSortField] = useState(null);

    const getdata = async () => {
		setLoader(true);
		try {
			const response = await axios.get('https://api.trucoo.in/dealers/view/',{
			  headers: {
				'Content-Type': 'application/json',
				'X-API-KEY': 'erpTrucoo',
			  },
			});
			console.log(response.data);
			if(response.data.status === 'success'){
				setGetData(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
		setLoader(false);
	};

	// const onPageChange = (event) => {
	// 	setFirst(event.first);
	// };

	useEffect(() => {
		getdata();
	},[]);

	const searchData = async (input) => {

		try {
			const response = await axios.post('https://api.trucoo.in/dealers/view/', {search: input}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			//console.log(response.data);
			if(response.data.status === 'success'){
				setGetData(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};

	const handleChange = (e) => {
		const value = e.target.value;
		setSearch(value);
		searchData(value);
	};

	const proceedRemoveDealer = (id) => {
		setSelectedDealer(id);
		setShowPopup(true);
	};

	const cancelRemoveDealer = () => {
		setShowPopup(false);
		setSelectedDealer(null);
	};

	const proceedRemove = async () => {
		try {
		  const response = await axios.post(
			'https://api.trucoo.in/dealers/remove/',
			{ dealerId: selectedDealer },
			{
			  headers: {
				'Content-Type': 'application/json',
				'X-API-KEY': 'erpTrucoo',
			  },
			}
		  );
		  
		  //console.log(response.data);

		  if(response.data.status === 'success'){
			getdata();
		  }
		} catch (error) {
		  console.error('Error:', error.response || error.message);
		} finally {
		  setShowPopup(false);
		  setSelectedDealer(null);
		}
	};

	// console.log(getData);

	// const getCsv = async() => {

	// 	try {
	// 	  const response = await axios.get(
	// 		'https://api.trucoo.in/dealers/ledger/',
	// 		{
	// 		  headers: {
	// 			'Content-Type': 'application/json',
	// 			'X-API-KEY': 'erpTrucoo',
	// 		  },
	// 		}
	// 	  );

	// 	  if(response.data.status === 'success'){
	// 		// Map your data into a clean array of objects
	// 		const rows = response?.data?.data?.map(data => ({
	// 			id: data.id,
	// 			name: data.name,
	// 			invoice: parseFloat(data.invoiceTotal).toFixed(2),
	// 			discount: parseFloat(data.discountTotal).toFixed(2),
	// 			recept: parseFloat(data.paymentTotal).toFixed(2)
	// 		}));

	// 		// Convert array → CSV
	// 		const headers = Object.keys(rows[0]).join(","); 
	// 		const values = rows.map(obj =>
	// 			Object.values(obj)
	// 			.map(value => `"${value}"`) // quote values for safety
	// 			.join(",")
	// 		);

	// 		const csvString = [headers, ...values].join("\n");
	// 		return csvString;
	// 	  }
	// 	} catch (error) {
	// 	  console.error('Error:', error.response || error.message);
	// 	}
	// };

	// const downloadCsv = async () => {
	// 	const csv = await getCsv();

	// 	const blob = new Blob([csv], { type: "text/csv" });
	// 	const url = URL.createObjectURL(blob);

	// 	const link = document.createElement("a");
	// 	link.href = url;
	// 	link.download = "data.csv";
	// 	link.click();

	// 	URL.revokeObjectURL(url);
	// };

	// downloadCsv();
	
	const formatViewDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${newDate.getFullYear()}`;
        return formattedDate;
    };

	// Sort by ID
	const sortById = () => {
		const sorted = [...getData].sort((a, b) => a.id - b.id);
		setGetData(sorted);
		setSortField('id');
	};

	// Sort by Name (alphabetical)
	const sortByName = () => {
		const sorted = [...getData].sort((a, b) => a.dealer.localeCompare(b.dealer));
		setGetData(sorted);
		setSortField('name');
	};

	// Sort by Date
	const sortByDate = () => {
		const sorted = [...getData].sort((a, b) => new Date(a.date) - new Date(b.date));
		setGetData(sorted);
		setSortField('date');
	};

	const sortByGroup = () => {
		const sorted = [...getData].sort((a, b) => new Date(a.group) - new Date(b.group));
		setGetData(sorted);
		setSortField('group');
	};

return(
<>
{loader && <Loader /> }
	<div class="overlay" style={{display: showPopup ? 'flex' : 'none'}}>
    	<div class="popup">
			<img src={Warning} width='90px' />
			<h4 class="text-bold mt-2 mb-2">Delete Dealer</h4>
      		<p>Would you like to delete this Dealer?</p>
			<button class="btn btn-success mx-3" onClick={proceedRemove}><i class="fa fa-trash"></i></button>
      		<button class="btn btn-danger mx-3"  onClick={cancelRemoveDealer} ><i class="fa fa-close"></i></button>
    	</div>
  	</div>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
				<div class="box">
					<div class="box-header with-border">
					    <div className="row" >
                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12" >
				  				<h4 class="box-title">Client Data</h4>
				  				<p class="mb-0 box-subtitle">All Clients Data</p>
				  			</div>
				  			<div className="col-xxl-1 col-xl-1 col-lg-1 col-md-6 col-12" ></div>
				  			<div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12" >
								<div className='input-group'>
									<button className={`btn btn-sm ${sortField === 'id' ? 'btn-primary' : 'btn-secondary'}`} onClick={sortById}>Sort by ID</button>
									<button className={`btn btn-sm ${sortField === 'name' ? 'btn-primary' : 'btn-secondary'}`} onClick={sortByName}>Sort by Name</button>
									<button className={`btn btn-sm ${sortField === 'date' ? 'btn-primary' : 'btn-secondary'}`} onClick={sortByDate}>Sort by Date</button>
									<button className={`btn btn-sm ${sortField === 'group' ? 'btn-primary' : 'btn-secondary'}`} onClick={sortByGroup}>Sort by Group</button>
								</div>
							</div>
				  			<div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-12" >
				  				<input type="text" class="form-control" placeholder='Enter Dealer Name' value={search} onChange={(e)=> {handleChange(e)}} />
				  			</div>
						</div>
					</div>
					<div class="box-body">
						<div className="table-responsive" style={{width: '100%', height: '65vh', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                        	<table style={{whiteSpace: 'nowrap'}} className="table-sm table-bordered nowrap fs-10" id="printableArea" width='100%'>
								<thead>
									<tr className="text-dark text-center" style={{ position: 'sticky', top: 0, zIndex: 2, backgroundColor: '#f8f9fa', padding: '10px' }}>
										<th>S.No</th>
										<th>Added On</th>
										<th>Group</th>
										<th>Dealer ID</th>
										<th>Dealers</th>
										<th>GST</th>
										<th>PAN</th>
										<th>Route</th>
										<th>Place</th>
										<th>Email</th>
										<th>Phone</th>
										<th>Invoice Value</th>
										<th>Receipts</th>
										<th>Balance</th>
										<th>Ledger Limit</th>
										<th width="10%" colspan="2">Options</th>
									</tr>
								</thead>
								<tbody>
									{getData.length > 0 ? getData?.map((data, index) => {
										
										const invTotal = parseFloat(data?.invoiceTotal);
										const disTotal = parseFloat(data?.discountTotal);
										const resTotal = parseFloat(data?.receiptTotal);
										const bal = (invTotal - disTotal) - resTotal;

									return(
									<tr key={index} class="text-dark text-center">
										<td>{index + first + 1}</td>
										<td class="text-center">{formatViewDate(data.date)}</td>
										<td class="text-center">{data.group}</td>
										<td class="text-center">{data.id}</td>
										<td class="text-start">{data.dealer}</td>
										<td>{data.gst}</td>
										<td>{data.pan}</td>
										<td>{data.route}</td>
										<td>{data.location}</td>
										<td>{data.email}</td>
										<td>{data.phone}</td>
										<td>{Number((invTotal - disTotal)).toFixed(2)}</td>
										<td>{Number(resTotal).toFixed(2)}</td>
										<td
											style={{
												color:
												bal > 500000
													? "#ab0909ff"
													: bal > 200000
													? "#00b8c5ff"
													: bal > 100000
													? "#000fdaff"
													: bal > 0
													? "#7000ccff"
													: "#00b603ff"
											}}
										>
											{Number(bal).toFixed(2)}
										</td>
										<td
										style={{
												background:
												bal > data?.ledgerLimit
													? "#ff562f"
													: "#6ec970ff"
											}}
										>{data?.ledgerLimit}</td>
										<td>
											<a href={`/edit-dealer?id=${data.id}`} class="btn btn-sm btn-secondary" style={{textAlign: 'center'}} ><i class="fa fa-edit"></i></a>
										</td>
										<td>
											<button onClick={()=>proceedRemoveDealer(data.id)} class="btn btn-sm btn-danger" style={{textAlign: 'center'}} ><i class="fa fa-trash"></i></button>
										</td>
									</tr>

									)}):(
										<tr>
											<td colSpan={10}>No Dealer Data</td>
										</tr>
									)}
									
								</tbody>	
							</table>

		 			{/* <Paginator className="custom-paginator" first={first} rows={rows} totalRecords={getData?.length}  onPageChange={onPageChange} /> */}

						</div>              
					</div>
			  	</div>
			</section>
		</div>
	</div>

	{/* <Footer /> */}
</>
);
}

export default App;